// extracted by mini-css-extract-plugin
export default {"truncateLineClamp":"Truncate_truncateLineClamp__G7V7i typography_truncate__xRrIs"};